import React, { useState } from 'react';
import { GatsbyImage, getImage, StaticImage } from 'gatsby-plugin-image';
import ReactPlayer from 'react-player/youtube';


// Assets
import PlayIcon from '§/src/images/svg/play.svg';

// Internal dependencies.
import './_tile-content-video.scss';

const TileContentVideo = ({
  featuredimage,
  image,
  date,
  title,
  subtitle,
  uri,
  video,
  categories,
  playText,
  preload,
  hasRivo,
  ...props
}) => {
  const atomClassName = 'tile-content-video';
  const atomClass = props.className !== undefined ? `${atomClassName} ${props.className}` : atomClassName;
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  // const [videoLoaded, setVideoLoaded] = useState(false);

  // Gestisce il precaricamento del video all'hover
  // const handleMouseEnter = () => {
  //   setVideoLoaded(true);
  // };

  const [eventSent, setEventSent] = useState(false);

  // Funzione per inviare l'evento di conversione a Google Tag Manager
  const sendConversionEvent = () => {
    if (!eventSent) {
      window.gtag && window.gtag('event', 'conversion-video-play', {'send_to': 'AW-966816152/3FNECOrupqMZEJjjgc0D'});
      window.gtag && window.gtag(
        'event', 'conversion_video_analytics',
        {
          'send_to': 'G-47QL2NE1ZW',
          'event_label': title,
        }
      );
      setEventSent(true); // Imposta eventSent su true dopo l'invio dell'evento
    }
  };

  // Gestisce il click sulla card e il play del video
  const handleClick = (event) => {
    if (event) event.stopPropagation(); // Impedisce la propagazione dell'evento solo se event esiste
    setIsVideoPlaying(true);
    sendConversionEvent(); // Chiama la funzione per inviare l'evento di conversione
  };

  // Gestisce la pausa o la fine del video
  const handleStop = () => {
    setIsVideoPlaying(false);
  };

  return (
    <div className={atomClass} onClick={!isVideoPlaying && !uri ? (event) => handleClick(event) : undefined}>
      <div className={`card h-100 ${isVideoPlaying ? 'reproducing' : ''}`}>
        <div className={`card-image position-relative ${!isVideoPlaying ? 'overlay' : ''}`}>
            {(hasRivo) &&
            <div className="rivo">
              <StaticImage
                src="../../../images/rivo/rivo-video.webp"
                placeholder="blurred"
                alt={"rivo-video"}
              />
            </div>
          }
          {(featuredimage || image) && (
            <GatsbyImage
              className="sw-image"
              image={getImage(featuredimage?.node?.gatsbyImage || image)}
              objectFit="cover"
              fit="cover"
              alt={featuredimage?.node?.altText || image?.altText || 'video image'}
            />
          )}
          <div className={`play-button ${isVideoPlaying ? 'd-none' : ''}`}>
            <PlayIcon />
            <span>{playText || "Guarda il video"}</span>
          </div>
        </div>
        {(!uri && video) && (
          <ReactPlayer
            url={video}
            playing={isVideoPlaying}
            controls={true}
            config={{
              youtube: {
                playerVars: { showinfo: 0, modestbranding: 1, rel: 0 }
              }
            }}
            width='100%'
            height='100%'
            onPlay={handleClick}
            onPause={handleStop}
            onEnded={handleStop}
          />
        )}
        {(uri || title) && (
          <div className="card-info pt-md-3">
            <div className="d-flex flex-column gap-3">
              {uri ? (
                <a
                  href={uri}
                  className={`h4 fw-bold m-0 stretched-link ${title && subtitle ? 'doubletitle px-3 px-sm-0' : ''}`}
                >
                  {title && <span className="title">{title}</span>}
                  {subtitle && <span className="subtitle">{subtitle}</span>}
                </a>
              ) : (
                <a
                  href="#"
                  onClick={(e) => e.preventDefault()}
                  className={`h4 fw-bold m-0 ${title && subtitle ? 'doubletitle px-3 px-sm-0' : ''}`}
                >
                  {title && <span className="title">{title}</span>}
                  {subtitle && <span className="subtitle">{subtitle}</span>}
                </a>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TileContentVideo;
